import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useSearchOptListStore = defineStore(
  'search', 
  () => {
    const searchParams = ref([])
    
    function searchParamsData(data){
      searchParams.value = data
    }

    return { searchParams , searchParamsData}
  },
  {
    persist: { key:'SearchOptList', storage:sessionStorage },
  },
)